import React from 'react'
import { Box } from '@material-ui/core'
import { useSelector } from 'react-redux'
import WhatsNewCard from './WhatsNewCard'
import ItemCounter from './ItemCounter'
import styles from '../WhatsNewStyles'

const WhatsNewList = ({ articles }) => {
  const classes = styles()
  const [itemCount, setItemCount] = React.useState(1)
  const userLocation = useSelector(
    (state) => state.myProfile?.userProfile?.location,
  )
  const campus = [
    {
      label: 'New Brunswick',
      value: 'newbrunswick',
    },
    {
      label: 'Newark',
      value: 'newark',
    },
    {
      label: 'Camden',
      value: 'camden',
    },
  ]
  const [userCampus, setUserCampus] = React.useState(campus[0].value)

  React.useEffect(() => {
    const defaultLocation = userLocation
    if (defaultLocation) {
      const filteredCampusMenu = campus.filter(
        (place) => place.label === defaultLocation,
      )
      if (filteredCampusMenu.length > 0) {
        setUserCampus(filteredCampusMenu[0].value)
      }
    }
  }, [userLocation])

  const filteredArticles = React.useMemo(() => {
    if (!Array.isArray(articles)) return []

    return articles.filter((article) => {
      if (!article?.campus) return true
      if (!userCampus) return false

      return Array.isArray(article.campus)
        ? article.campus.includes(userCampus)
        : article.campus === userCampus
    })
  }, [articles, userCampus])
  const visibleArticleCount = filteredArticles.length

  // const sentinelRef = React.useRef(null)
  const rootViewRef = React.useRef(null)
  const itemCounterWrapper = React.useRef(null)
  const cardSize = 305
  let isScrolling
  function handleScroll() {
    // console.log('height scroll')
    clearTimeout(isScrolling)
    const currentScroll = rootViewRef?.current?.scrollTop
    const itemCounterWrapperStyle = itemCounterWrapper?.current.style
    itemCounterWrapperStyle.opacity = 1
    itemCounterWrapperStyle.transition = ' opacity 0.1s ease-out'
    isScrolling = setTimeout(() => {
      itemCounterWrapperStyle.transition = ' opacity 0.5s ease-out'
      itemCounterWrapperStyle.opacity = 0
    }, 500)

    setItemCount(Math.trunc(currentScroll / cardSize) + 1)
  }
  React.useEffect(() => {
    rootViewRef?.current?.addEventListener('scroll', handleScroll)

    return () => {
      rootViewRef?.current?.removeEventListener('scroll', handleScroll)
    }
  }, [rootViewRef])

  // React.useEffect(() => {
  //   // let lastY = 0
  //   const observer = new IntersectionObserver(
  //     ([entry]) => {
  //       if (entry.isIntersecting) {
  //         // const currentY = entry.boundingClientRect.y
  //         if (entry.boundingClientRect.top < entry.rootBounds.top) {
  //           console.log(
  //             'Check top: ',
  //             entry.boundingClientRect.top,
  //             'Check rootBounds: ',
  //             entry.rootBounds.top,
  //           )
  //           setItemCount((prevCount) => prevCount - 1)
  //         } else {
  //           setItemCount((prevCount) => prevCount + 1)
  //         }
  //         // lastY = currentY
  //       }
  //     },
  //     {
  //       root: rootViewRef?.current, // Use the viewport as the root when passing null
  //       rootMargin: '-300px 0px 100px 0px', // 10px margin
  //       threshold: 0, // Trigger when the observed element when it is fully visible
  //     },
  //   )

  //   // acquire all list items via parent (rootViewRef)
  //   // assign the observer to each element
  //   const listelements = rootViewRef?.current.children
  //   Array.from(listelements).forEach((child) => {
  //     observer.observe(child)
  //   })
  //   // remove observer from each element on leaving page
  //   return () => {
  //     if (rootViewRef.current) {
  //       Array.from(listelements).forEach((child) => {
  //         observer.unobserve(child)
  //       })
  //     }
  //   }
  // }, [])

  // console.log('listitem: ', listItem)
  // Intersection is checked at the bottom of the rootViewRef!
  // try add it in the middle as in the bottom of the first item
  return (
    <Box id="item-list-container">
      <ItemCounter
        ref={itemCounterWrapper}
        numOfItems={visibleArticleCount}
        itemNum={itemCount}
        classes={classes}
      />
      <Box
        id="item-root-view"
        className={classes.listContainer}
        ref={rootViewRef}
      >
        {filteredArticles.map((item, i) => (
          <Box key={item.name} id={`item${i}`} className={classes.cardBox}>
            <WhatsNewCard itemData={item} />
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default WhatsNewList
